import { LocationResponse } from "client/scanner/scanner.types"

export const validateLocationToDrop = (location: LocationResponse) => {
  const LOCATION_DROP_REGEX = /^[A-Z]{2,3}-ALM-P[0-9]+-R[0-9]+$/
  if (LOCATION_DROP_REGEX.test(location.name))
    return location
  else 
    throw new Error('La ubicación no es de almacenamiento de piso')
}
